module.exports = __webpack_public_path__ + "static/hillelujah-logo-fullsize-d7cd63c41ebb49acb7c2fe6bc9d63da6.jpg";